import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DialogConfig, DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import { Messages } from '@tmhcc-ng-lib/models';
import { CustomModalComponent } from 'libs/artisan-edge/src/lib/custom-modal/custom-modal.component';

@Component({
  selector: 'ae-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {
  @Input() paymentMethod: string;
  @Input() paymentDetails;
  @Output() purchageClicked = new EventEmitter<string>();
  paymentData = [];
  isFormCompleted: boolean;
  installmentBillAgrMessage: string = '';
  modalTitle: string = 'PAYMENT METHOD';

  modalContent: DialogConfig = {
    data: {
      para: '',
      footerBtnLabel: '',
      showFooterBtn: true
    },
    modalSetting: {
      title: '',
      hideHeader: false,
      hideFooter: true,
      hideHeaderX: false, // header X button;
      hideSave: true,
      closeOnOutsideClick: true
    }
  };
  @Input() installmentBillingAggrement: boolean;

  constructor(private dialogService: DialogService) {}

  ngOnInit(): void {
    this.paymentData = this.paymentDetails;
    this.installmentBillAgrMessage = Messages.InstallmentBillAgrMessage;
    window.scrollTo(0, 0);
  }

  purchase(billingType) {
    this.purchageClicked.emit(billingType);
  }

  getDescription(method) {
    return this.paymentData.find(item => item.Name === method).Description;
  }
}
